import { render, staticRenderFns } from "./stockQualityWait.vue?vue&type=template&id=40deb1d6&scoped=true"
import script from "./stockQualityWait.vue?vue&type=script&lang=js"
export * from "./stockQualityWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40deb1d6",
  null
  
)

export default component.exports